import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { GetPoliciesQueryVariables } from '../gql/graphql';

export const GET_POLICIES = graphql(`
  query getPolicies(
    $pagination: PaginationRequest
    $filters: PolicyFilterInput
    $sort: PaginationSort
  ) {
    policies(pagination: $pagination, filters: $filters, sort: $sort) {
      pageInfo {
        totalResults
        pageNumber
        pageSize
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          type
          status
          referenceId
          brokerCommissionAmount
          stateTax
          policyFee
          stampingFee
          boundPremium
          grossPremium
          netPremium
          startDate
          endDate
          transactionDate
          createdAt
          updatedAt
          insuredName
          documentLink
          isActive
        }
      }
    }
  }
`);
export function useGetPoliciesQuery(variables: GetPoliciesQueryVariables) {
  const { loading, error, data } = useQuery(GET_POLICIES, {
    variables,
  });

  const policies = useMemo(() => {
    if (!data || !data.policies || !data.policies.edges) {
      return [];
    }
    return data.policies.edges.map((edge) => {
      return {
        uuid: edge.node.uuid as string,
        referenceId: edge.node.referenceId ?? '',
        type: edge.node.type ?? '',
        status: edge.node.status ?? '',
        stateTax: edge.node.stateTax,
        policyFee: edge.node.policyFee,
        stampingFee: edge.node.stampingFee,
        boundPremium: edge.node.boundPremium,
        grossPremium: edge.node.grossPremium,
        netPremium: edge.node.netPremium,
        startDate: edge.node.startDate ?? '',
        endDate: edge.node.endDate ?? '',
        transactionDate: edge.node.transactionDate ?? '',
        insuredName: edge.node.insuredName ?? '',
        documentLink: edge.node.documentLink ?? '',
        createdAt: edge.node.createdAt ?? '',
        updatedAt: edge.node.updatedAt ?? '',
      };
    });
  }, [data]);

  return {
    error,
    loading,
    data,
    policies,
  };
}
